// removed by extract-text-webpack-plugin
module.exports = {"mainContainer":"CoreLayout__mainContainer___165Y4"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CoreLayout/CoreLayout.css
// module id = 1057
// module chunks = 24